export default __webpack_public_path__ + "static/media/UFO.6e2c7687.png";